export default "__VITE_ASSET__DEjYeMPI__"